import { Component, ElementRef, HostListener, Output, EventEmitter, ViewChild } from '@angular/core';

@Component({
    selector: 'file-upload-link',
    template: `
        <input class="file-input" type="file" #file style="display: none;">
        <a (click)="file.click()" style="cursor: pointer;">
            <ng-content></ng-content>
        </a>
    `
})
export class FileUploadLinkComponent {
    @Output() fileSelected = new EventEmitter<File>();

    @HostListener('change', ['$event.target.files']) emitFiles( event: FileList ) {
        this.fileSelected.emit(event && event.item(0));
    }

    constructor( private host: ElementRef<HTMLInputElement> ) {}
}